<template>
    <div class="optional-sign-up-container">
        <h1>{{ $t("signInUp.createAccount") }}</h1>
        <div
            class="intro-signUp"
            v-if="$t('optionalSignUp.intro').length"
            v-html="$t('optionalSignUp.intro')"
        ></div>

        <router-link to="SignUp" class="sign-up-button">
            {{ $t("optionalSignUp.createAccount") }}
            <br />
            ( {{ $t("optionalSignUp.recommended") }} )
        </router-link>

        <div class="delimiter">
            <hr />
            <span>
                {{ $t("general.or").toUpperCase() }}
            </span>
            <hr />
        </div>

        <router-link to="Upload" class="skip-button">
            {{ $t("optionalSignUp.noSignUp") }}
        </router-link>

        <div class="view-footer">
            <RGPDLink />
            <GcuLink class="gcu-link" v-if="$t('general.GCU').length" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";

import RGPDLink from "@/components/RGPDLink.vue";
import GcuLink from "@/components/gcuLink.vue";
import { State } from "@/store";

export default defineComponent({
    name: "Signup",
    components: {
        GcuLink,
        RGPDLink
    },
    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            authenticated: (state: State) => state.auth.authenticated
        })
    },
    mounted() {

        if (this.authenticated) {
            this.$router.replace("Upload");
        }
    }
});
</script>

<style scoped>
h1 {
    margin: 0;
    color: var(--screenTextColor);
}

.optional-sign-up-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
}

.intro-signUp {
    color: var(--screenTextColor);
    margin: 5px 15px;
}

.signin-link {
    color: var(--screenTextColor);
    grid-column: 1 / 3;
}

.delimiter {
    display: flex;
    flex-direction: row;
    padding-left: 15px;
    padding-right: 15px;
    width: calc(100% - 30px);
    margin-top: 10px;
    margin-bottom: 10px;
}

.delimiter hr {
    flex-grow: 1;
    height: 1px;
    border: 0;
    border-top: 1px solid var(--black);
    opacity: 0.6;
}

.delimiter span {
    flex-grow: 0;
    margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);
</style>
<style>
/* because link added with v-html, not concerned by scoped style */
.intro-signUp a {
    color: var(--screenTextColor) !important;
}

.sign-up-button,
.skip-button {
    flex-grow: 1;
    text-decoration: none;
    border-radius: 5px;
    padding: 15px;
    font-weight: bold;
    font-size: 1.05em;
}

.sign-up-button {
    background-color: var(--secondary);
    color: var(--buttonTextColor);
}

.skip-button {
    background-color: var(--buttonTextColor);
    color: var(--secondary);
    padding: 25px 15px;
}
</style>
